module.exports = __webpack_public_path__ + "img/psicologia-positiva-2.2e79e67e.jpg";